// Registry of the shared grammar quiz data.
//
// Topic lesson JSONs reference a grammar point by slug
// ({ type: "grammarquiz", grammarPoint: "passive", topic: "Automation" })
// and TopicsRouter looks the quiz file up here. The file's
// questions are passed through whole so the topic dropdown
// still offers the full pool; TopicsSection starts on the
// lesson's own questions (the `topic` field = lesson name).
//
// Keys are the grammar-point slugs used by the topic pages.
// "comparisons" (B1) shares the comparison-quiz file, and
// sense verbs live in sense-quiz.
import adjAdvQuiz from '../../../Shared/Activities/Data/quiz/adj-adv-quiz.json';
import causeEffectQuiz from '../../../Shared/Activities/Data/quiz/cause-effect-quiz.json';
import collocationsQuiz from '../../../Shared/Activities/Data/quiz/collocations-quiz.json';
import comparisonQuiz from '../../../Shared/Activities/Data/quiz/comparison-quiz.json';
import conditionalsQuiz from '../../../Shared/Activities/Data/quiz/conditionals-quiz.json';
import dependentPrepositionsQuiz from '../../../Shared/Activities/Data/quiz/dependent-prepositions-quiz.json';
import descriptiveAdjectivesQuiz from '../../../Shared/Activities/Data/quiz/descriptive-adjectives-quiz.json';
import deviceVerbsQuiz from '../../../Shared/Activities/Data/quiz/device-verbs-quiz.json';
import edIngQuiz from '../../../Shared/Activities/Data/quiz/ed-ing-quiz.json';
import firstCondQuiz from '../../../Shared/Activities/Data/quiz/first-cond-quiz.json';
import futureQuiz from '../../../Shared/Activities/Data/quiz/future-quiz.json';
import gerundsQuiz from '../../../Shared/Activities/Data/quiz/gerunds-quiz.json';
import gerundsInfinitivesQuiz from '../../../Shared/Activities/Data/quiz/gerunds-infinitives-quiz.json';
import habitsQuiz from '../../../Shared/Activities/Data/quiz/habits-quiz.json';
import indirectSpeechQuiz from '../../../Shared/Activities/Data/quiz/indirect-speech-quiz.json';
import infinitivesQuiz from '../../../Shared/Activities/Data/quiz/infinitives-quiz.json';
import introductionsQuiz from '../../../Shared/Activities/Data/quiz/introductions-quiz.json';
import linkingWordsQuiz from '../../../Shared/Activities/Data/quiz/linking-words-quiz.json';
import canQuiz from '../../../Shared/Activities/Data/quiz/can-quiz.json';
import modalsDeductionQuiz from '../../../Shared/Activities/Data/quiz/modals-deduction-quiz.json';
import modalsObligationQuiz from '../../../Shared/Activities/Data/quiz/modals-obligation-quiz.json';
import moneyIdiomsQuiz from '../../../Shared/Activities/Data/quiz/money-idioms-quiz.json';
import passiveQuiz from '../../../Shared/Activities/Data/quiz/passive-quiz.json';
import passiveBeingQuiz from '../../../Shared/Activities/Data/quiz/passive-being-quiz.json';
import passiveGetQuiz from '../../../Shared/Activities/Data/quiz/passive-get-quiz.json';
import passiveReportingQuiz from '../../../Shared/Activities/Data/quiz/passive-reporting-quiz.json';
import pastContinuousQuiz from '../../../Shared/Activities/Data/quiz/past-continuous-quiz.json';
import pastHabitsQuiz from '../../../Shared/Activities/Data/quiz/past-habits-quiz.json';
import perfectPastQuiz from '../../../Shared/Activities/Data/quiz/perfect-past-quiz.json';
import presentContinuousQuiz from '../../../Shared/Activities/Data/quiz/present-continuous-quiz.json';
import presentPerfectQuiz from '../../../Shared/Activities/Data/quiz/present-perfect-quiz.json';
import provideVerbQuiz from '../../../Shared/Activities/Data/quiz/provide-verb-quiz.json';
import punctuationQuiz from '../../../Shared/Activities/Data/quiz/punctuation-quiz.json';
import relativeClausesQuiz from '../../../Shared/Activities/Data/quiz/relative-clauses-quiz.json';
import reportedSpeechQuiz from '../../../Shared/Activities/Data/quiz/reported-speech-quiz.json';
import secondCondQuiz from '../../../Shared/Activities/Data/quiz/second-cond-quiz.json';
import senseQuiz from '../../../Shared/Activities/Data/quiz/sense-quiz.json';
import simpContQuiz from '../../../Shared/Activities/Data/quiz/simp-cont-quiz.json';
import simplePastQuiz from '../../../Shared/Activities/Data/quiz/simple-past-quiz.json';
import simplePresentQuiz from '../../../Shared/Activities/Data/quiz/simple-present-quiz.json';
import smartphoneQuiz from '../../../Shared/Activities/Data/quiz/smartphone-quiz.json';
import soEnoughQuiz from '../../../Shared/Activities/Data/quiz/so-enough-quiz.json';
import soSuchQuiz from '../../../Shared/Activities/Data/quiz/so-such-quiz.json';
import someAnyQuiz from '../../../Shared/Activities/Data/quiz/some-any-quiz.json';
import suggestQuiz from '../../../Shared/Activities/Data/quiz/suggest-quiz.json';
import tenseQuiz from '../../../Shared/Activities/Data/quiz/tense-quiz.json';
import thirdCondQuiz from '../../../Shared/Activities/Data/quiz/third-cond-quiz.json';
import toBePastQuiz from '../../../Shared/Activities/Data/quiz/to-be-past-quiz.json';
import toBePresentQuiz from '../../../Shared/Activities/Data/quiz/to-be-present-quiz.json';
import unlessQuiz from '../../../Shared/Activities/Data/quiz/unless-quiz.json';
import usedToQuiz from '../../../Shared/Activities/Data/quiz/used-to-quiz.json';
import wishQuiz from '../../../Shared/Activities/Data/quiz/wish-quiz.json';
import wordFormsQuiz from '../../../Shared/Activities/Data/quiz/word-forms-quiz.json';
import zeroCondQuiz from '../../../Shared/Activities/Data/quiz/zero-cond-quiz.json';

const grammarQuizzes = {
  'adj-adv': adjAdvQuiz,
  'cause-effect': causeEffectQuiz,
  collocations: collocationsQuiz,
  comparison: comparisonQuiz,
  comparisons: comparisonQuiz,
  conditionals: conditionalsQuiz,
  'dependent-prepositions': dependentPrepositionsQuiz,
  'descriptive-adjectives': descriptiveAdjectivesQuiz,
  'device-verbs': deviceVerbsQuiz,
  'ed-ing': edIngQuiz,
  'first-cond': firstCondQuiz,
  future: futureQuiz,
  gerunds: gerundsQuiz,
  'gerunds-infinitives': gerundsInfinitivesQuiz,
  habits: habitsQuiz,
  'indirect-speech': indirectSpeechQuiz,
  infinitives: infinitivesQuiz,
  introductions: introductionsQuiz,
  'linking-words': linkingWordsQuiz,
  can: canQuiz,
  'modals-deduction': modalsDeductionQuiz,
  'modals-obligation': modalsObligationQuiz,
  'money-idioms': moneyIdiomsQuiz,
  passive: passiveQuiz,
  'passive-being': passiveBeingQuiz,
  'passive-get': passiveGetQuiz,
  'passive-reporting': passiveReportingQuiz,
  'past-continuous': pastContinuousQuiz,
  'past-habits': pastHabitsQuiz,
  'perfect-past': perfectPastQuiz,
  'present-continuous': presentContinuousQuiz,
  'present-perfect': presentPerfectQuiz,
  'provide-verb': provideVerbQuiz,
  punctuation: punctuationQuiz,
  'relative-clauses': relativeClausesQuiz,
  'reported-speech': reportedSpeechQuiz,
  'second-cond': secondCondQuiz,
  'sense-verbs': senseQuiz,
  'simp-cont': simpContQuiz,
  'simple-past': simplePastQuiz,
  'simple-present': simplePresentQuiz,
  smartphone: smartphoneQuiz,
  'so-enough': soEnoughQuiz,
  'so-such': soSuchQuiz,
  'some-any': someAnyQuiz,
  suggest: suggestQuiz,
  tense: tenseQuiz,
  'third-cond': thirdCondQuiz,
  'to-be-past': toBePastQuiz,
  'to-be-present': toBePresentQuiz,
  unless: unlessQuiz,
  'used-to': usedToQuiz,
  wish: wishQuiz,
  'word-forms': wordFormsQuiz,
  'zero-cond': zeroCondQuiz,
};

export default grammarQuizzes;
